import {PayoffPaymentTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function payoffPaymentTypeNameFilter(type: PayoffPaymentTypeEnum) {
  switch (type) {
    case PayoffPaymentTypeEnum.Cash: return i18n.t(LF.Cash) as string;
    case PayoffPaymentTypeEnum.Transfer: return i18n.t(LF.Transfer) as string;
    case PayoffPaymentTypeEnum.Card: return i18n.t(LF.Card) as string;
  }
}
